<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-alert type="info" show-icon style="margin-bottom: 16px;">
        <template slot="message">
          设置各会员等级「消费1元赠送的积分数量」。例如填写 1，表示用户每消费1元赠送1积分（按整单实付金额计算）。
        </template>
      </a-alert>

      <div class="table-operations" style="margin-bottom: 16px;">
        <a-button type="primary" :loading="saveLoading" @click="handleSave" v-hasPermi="['retail:inventory:setPrice']">
          <a-icon type="save" />保存配置
        </a-button>
      </div>

      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="levelId"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="levelName" slot-scope="text, record">
          {{ record.levelName }}
        </span>
        <span slot="giftPointRate" slot-scope="text, record">
          <a-input-number
            v-model="record.giftPointRate"
            :min="0"
            :max="999"
            :precision="2"
            :step="0.1"
            style="width: 160px;"
            addon-after="积分/元"
          />
        </span>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { giftPointRateList, giftPointRateSave } from '@/api/retail/inventory'
import { listLevel } from '@/api/user/level'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'GiftPointRate',
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      loading: false,
      saveLoading: false,
      columns: [
        {
          title: '会员等级',
          dataIndex: 'levelName',
          scopedSlots: { customRender: 'levelName' },
          align: 'center',
          width: '40%'
        },
        {
          title: '积分赠送比例（消费1元赠送积分）',
          dataIndex: 'giftPointRate',
          scopedSlots: { customRender: 'giftPointRate' },
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.getList()
  },
  methods: {
    /** 加载会员等级 + 已配置比例 */
    getList () {
      this.loading = true
      // 先拉取平台会员等级列表
      listLevel().then(levelRes => {
        const levels = levelRes.data || []
        // 再拉取当前商家已配置的比例（比例表 levelId 存的是 user_user_level.sort）
        return giftPointRateList().then(rateRes => {
          const rateMap = {}
          ;(rateRes.data || []).forEach(item => {
            rateMap[item.levelId] = item.giftPointRate
          })
          this.list = levels.map(level => ({
            levelId: level.sort,
            levelName: level.levelName,
            giftPointRate: rateMap[level.sort] != null ? Number(rateMap[level.sort]) : 0
          }))
          this.loading = false
        })
      }).catch(() => {
        this.loading = false
      })
    },
    /** 保存配置 */
    handleSave () {
      this.saveLoading = true
      const params = this.list.map(item => ({
        levelId: item.levelId,
        giftPointRate: item.giftPointRate != null ? item.giftPointRate : 0
      }))
      giftPointRateSave(params).then(() => {
        this.$message.success('保存成功')
        this.getList()
      }).finally(() => {
        this.saveLoading = false
      })
    }
  }
}
</script>
